import * as React from 'react';
import * as styles from './Services.css';
import { Service } from '../Service';
import { Slider } from '../../../common/Slider';
import { MOBILE_SLIDER_INDENTS, DESKTOP_SLIDER_INDENTS, SLIDE_WIDTH } from './constants';
import { SERVICES_SLIDER_ID } from '../../../../constants/nodeIds';

export interface IServicesProps {
  isMobile: boolean;
  serviceIds: string[];
  activeServiceIndex?: number;
  onScrollSliderRight(): void;
  onScrollSliderLeft(): void;
}

export const Services = (props: IServicesProps) => {
  const { isMobile, serviceIds, activeServiceIndex, onScrollSliderRight, onScrollSliderLeft } = props;

  const services = serviceIds.map(serviceId => <Service key={serviceId} serviceId={serviceId} />);

  const indents = isMobile ? MOBILE_SLIDER_INDENTS : DESKTOP_SLIDER_INDENTS;

  return (
    <div className={styles['services']}>
      <Slider
        id={SERVICES_SLIDER_ID}
        initialSlide={activeServiceIndex}
        visibleSlides={3}
        additionalOffset={42}
        slideWidth={SLIDE_WIDTH}
        indents={indents}
        onScrollLeft={onScrollSliderLeft}
        onScrollRight={onScrollSliderRight}
      >
        {services}
      </Slider>
    </div>
  );
};
